import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

// Constants
const CURRENCY_FORMAT_OPTIONS = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

// Helper functions
const formatCurrency = (amount) =>
  `₱${Number(amount || 0).toLocaleString(undefined, CURRENCY_FORMAT_OPTIONS)}`;

const getChartOptions = (title, data) => ({
  chart: { type: "pie" },
  title: { text: title },
  tooltip: {
    formatter() {
      return `<b>${this.point.name}</b><br/>
              Total Count: ${this.y}<br/>
              Total Amount: ${formatCurrency(this.point.totalAmount)}`;
    },
  },
  plotOptions: {
    pie: {
      innerSize: "40%",
      size: "100%",
      allowPointSelect: true,
      cursor: "pointer",
      dataLabels: { enabled: false },
    },
  },
  series: [{ name: title, data }],
  credits: { enabled: false },
  legend: {
    enabled: true,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom",
    itemMarginBottom: 8,
  },
});

const Charts = ({ chartRef, chartContainerId, doughnutData }) => (
  <div
    ref={chartRef}
    id={chartContainerId}
    className="row row-cols-1 row-cols-md-3 g-4 mt-2"
  >
    {doughnutData.map((data, index) => (
      <div key={index} className="col">
        <HighchartsReact
          highcharts={Highcharts}
          options={getChartOptions(`Chart ${index + 1}`, data)}
        />
      </div>
    ))}
  </div>
);

export default Charts;
